import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import FootageSelectionTool from "legacy/assignments-v2/FootageSelectionTool"
import {
  afterSetState,
  capitalizeFirstLetter,
  fuzzysearch,
  inchesToFeet,
  isPresent,
} from "legacy/helpers.es6"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class AssignmentForm extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      loadingSpaces: false,
      spaceFilter: true,
      bufferFilter: true,
      lengthFilter: true,
      availableFilter: true,
      editingSpace: false,
      spacesBySpaceGroup: [],
    }
    this.handleDateChange = this.handleDateChange.bind(this)
    this.setAssignmentFormState = this.setAssignmentFormState.bind(this)
    this.renderSpaceInput = this.renderSpaceInput.bind(this)
  }

  componentDidMount() {
    this.fetchSpaces()
  }

  setAssignmentFormState(object) {
    this.setState(object)
    this.props.setGlobalState(object)
  }

  fetchSpaces() {
    const start = this.props.assignment.start_date
    const end = this.props.assignment.end_date
    if (start && end) {
      this.setState({ loadingSpaces: true })
      $.post(
        $context.availabilityBySpaceEndpoint,
        {
          start_date: start,
          end_date: end,
          reservation_id: this.props.reservationId,
        },
        (data) => {
          this.setState({
            loadingSpaces: false,
            spacesBySpaceGroup: data,
          })
        }
      )
    }
  }

  handleDateChange(date, name) {
    this.props.assignmentChange(
      name,
      moment(date, "MM/DD/YYYY").format("YYYY-MM-DD"),
      this.props.index
    )
    afterSetState(this.fetchSpaces.bind(this))
  }

  isSearching() {
    return isPresent(this.state.search)
  }

  searchedSpaceGroupData() {
    let searched = _.cloneDeep(this.state.spacesBySpaceGroup)
    const query = this.state.search.toLowerCase()
    searched = _.filter(
      _.map(searched, (spaceGroup) => {
        spaceGroup.spaces = _.filter(spaceGroup.spaces, (space) =>
          fuzzysearch(query, space.name.toLowerCase())
        )
        return spaceGroup
      }),
      (spaceGroup) => spaceGroup.spaces.length > 0
    )
    return searched
  }

  filteredSpaceGroupData() {
    let filtered = _.cloneDeep(this.state.spacesBySpaceGroup)
    if (this.state.spaceFilter) {
      filtered = _.filter(filtered, (spaceGroup) => {
        return (
          isPresent(spaceGroup.dock_type) &&
          this.props.spaceType.toLowerCase() ===
            spaceGroup.dock_type.toLowerCase()
        )
      })
    }
    if (this.state.lengthFilter) {
      filtered = _.filter(filtered, (spaceGroup) => {
        if (spaceGroup.type === "SpaceGroup::LinearV2") {
          spaceGroup.spaces = _.filter(spaceGroup.spaces, (space) => {
            return space.end_location - space.start_location >= this.props.loa
          })
          return (
            isPresent(spaceGroup.min_length) &&
            isPresent(spaceGroup.max_length) &&
            this.props.loa >= spaceGroup.min_length &&
            this.props.loa <= spaceGroup.max_length &&
            spaceGroup.spaces.length > 0
          )
        } else {
          return (
            isPresent(spaceGroup.min_length) &&
            isPresent(spaceGroup.max_length) &&
            this.props.loa >= spaceGroup.min_length &&
            this.props.loa <= spaceGroup.max_length
          )
        }
      })
    }
    if (this.state.availableFilter) {
      filtered = _.filter(filtered, (spaceGroup) => {
        spaceGroup.spaces = _.filter(spaceGroup.spaces, { available: true })
        return spaceGroup.spaces.length > 0
      })
    }
    return filtered
  }

  spaceGroupData() {
    const filteredSet = this.isSearching()
      ? this.searchedSpaceGroupData()
      : this.filteredSpaceGroupData()
    // fix up the order of spaces within the filtered space group set
    return _.map(filteredSet, (spaceGroup) => {
      spaceGroup.spaces = _.orderBy(spaceGroup.spaces, ["order"], ["asc"])
      return spaceGroup
    })
  }

  setSpace(spaceId, spaceGroupType) {
    if (spaceGroupType === "SpaceGroup::Linear") {
      Amplitude.trackEvent("assignments:assigned_linear_dockage_v1")
    }
    this.setState({ editingSpace: false }, () =>
      this.setAssignmentFormState({ selectingAssignment: false })
    )
    this.props.assignmentChange("space_id", spaceId, this.props.index)
  }

  renderSpaces(spaceGroup, spaces) {
    return _.map(spaces, (space) => {
      return (
        <div
          key={`space-${space.id}`}
          className={classNames(
            "bs-p-1 bs-pl-2 hover:bg-gray cursor-pointer rounded",
            {
              "border-green border border-dashed":
                this.props.assignment &&
                space.id === this.props.assignment.space_id,
            }
          )}
          onClick={() => this.setSpace(space.id, spaceGroup.type)}
        >
          {space.available ? (
            <i className="icon icon-circle-check-solid icon-fw text-status-green bs-mr-2" />
          ) : (
            <i
              className="icon icon-cancel icon-fw bs-mr-2"
              style={{ color: "#cecece" }}
            />
          )}
          <span
            className={classNames({
              "font-semibold": space.available,
              "text-muted": !space.available,
            })}
          >
            {space.name}
          </span>
        </div>
      )
    })
  }

  findSelectedRange(spaceGroup) {
    let selectedRange
    // calculate the midpoint of the boat, so we have one number to work with that we know will be in the space range
    const assignedBoatMidPoint =
      (this.props.assignment.bow_location +
        this.props.assignment.stern_location) /
      2
    // create an array of space range start and end locations
    const rangeValuesArray = _.uniq(
      _.flatMap(spaceGroup.spaces, (space) => [
        space.start_location,
        space.end_location,
      ])
    )
    // find the space with the closest start or end location to the assignedBoatMidpoint
    const closest = rangeValuesArray.reduce((a, b) => {
      return Math.abs(b - assignedBoatMidPoint) <
        Math.abs(a - assignedBoatMidPoint)
        ? b
        : a
    })
    const ranges = _.sortBy(
      _.filter(
        spaceGroup.spaces,
        (space) =>
          space.start_location === closest || space.end_location === closest
      ),
      "start_location"
    )
    if (ranges.length === 1) {
      selectedRange = ranges[0]
    } else {
      selectedRange =
        ranges[0].end_location > assignedBoatMidPoint ? ranges[0] : ranges[1]
    }
    // return the index of the selected range to use for comparing space ranges in the footage selection tool
    return _.findIndex(spaceGroup.spaces, selectedRange)
  }

  renderLinearDockageSpace(spaceGroup) {
    const rangeIndex = this.findSelectedRange(spaceGroup)
    return _.map(spaceGroup.spaces, (space, index) => {
      return (
        <FootageSelectionTool
          key={`${index}-${space.start_location}-${space.end_location}`}
          id={index}
          space={space}
          rangeIndex={rangeIndex}
          assignment={this.props.assignment}
          tieSide={
            isPresent(this.props.assignment.bow_location)
              ? this.props.assignment.bow_location >
                this.props.assignment.stern_location
                ? "port"
                : "starboard"
              : "starboard"
          }
          setLinearSpace={this.setLinearSpace}
          assignmentChange={this.props.assignmentChange}
          contactBoat={this.props.contactBoat}
          editingSpace={this.state.editingSpace}
          assignmentFormIndex={this.props.index}
          renderSpaceInput={this.renderSpaceInput}
          spaceName={this.props.spaceName}
          bufferFilter={this.state.bufferFilter}
          spaceGroup={spaceGroup}
          setAssignmentFormState={this.setAssignmentFormState}
        />
      )
    })
  }

  renderSpaceGroups() {
    const spaceData = this.spaceGroupData()
    if (spaceData.length) {
      return _.map(spaceData, (spaceGroup, index) => {
        return (
          <div key={`space-group-${spaceGroup.id}`}>
            <div
              className="text-muted sticky bg-white py-2 font-extrabold"
              style={{ top: 0, zIndex: 1 }}
            >
              {spaceGroup.name || "(no space group)"}
              {spaceGroup.type === "SpaceGroup::LinearV2" && (
                <div className="flex flex-row justify-between bg-white">
                  <div className="text-muted mr-1 mt-0.5 text-xs font-normal">
                    {this.state.availableFilter && "Available"} Continuous
                    Footage
                  </div>
                  {spaceGroup.buffer_size > 0 && (
                    <div className="flex flex-row-reverse">
                      <p
                        id="checkBoxLabel"
                        className="text-muted text-xs font-normal"
                        style={{ marginTop: "2px" }}
                      >{`Include ${inchesToFeet(
                        spaceGroup.buffer_size
                      )}' buffer`}</p>
                      <FormGroup
                        key={index}
                        inputType="checkbox"
                        name="bufferFilter"
                        value={this.state.bufferFilter}
                        onChange={this.handleInputChange}
                        className="my-0"
                        ariaLabelledBy="checkBoxLabel"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
            {spaceGroup.type === "SpaceGroup::LinearV2"
              ? this.renderLinearDockageSpace(spaceGroup)
              : this.renderSpaces(spaceGroup, spaceGroup.spaces)}
          </div>
        )
      })
    } else {
      return (
        <div className="text-muted text-center">
          No spaces for filter. Clear filters or search.
        </div>
      )
    }
  }

  renderSpaceInput() {
    return (
      <div
        className="flex cursor-pointer justify-between rounded border bg-white px-4 py-3"
        onClick={() =>
          this.setState(
            { editingSpace: true },
            this.setAssignmentFormState({ selectingAssignment: true })
          )
        }
      >
        <span>{this.props.spaceName}</span>
        <span className="text-link-blue">
          Edit
          <i className="icon icon-chevron-down ml-2" />
        </span>
      </div>
    )
  }

  renderAssignWidget() {
    return (
      <div
        className="w-full rounded border bg-white"
        style={{ overflow: "hidden" }}
      >
        <div className="bg-gray flex w-full items-center space-x-2 border-b p-3">
          <div className="form-control-with-icon flex-grow">
            {this.isSearching() ? (
              <i
                className="icon icon-times form-control-icon-right cursor-pointer"
                style={{ top: 7 }}
                onClick={() => this.setState({ search: "" })}
              />
            ) : (
              <i
                className="icon icon-search-fa form-control-icon-right"
                style={{ top: 7 }}
              />
            )}
            <input
              className="form-control input-sm px-3 py-2"
              type="text"
              value={this.state.search}
              name="search"
              onChange={this.handleInputChange}
              placeholder="Search"
              autoComplete="off"
            />
          </div>
          {this.props.spaceName && (
            <button
              className="btn btn-secondary btn-sm"
              type="button"
              onClick={() => this.setState({ editingSpace: false })}
            >
              Close
            </button>
          )}
        </div>
        <div className="p-3">
          <div className="flex w-full items-center justify-between">
            <FormGroup
              inputType="checkbox"
              name="spaceFilter"
              value={this.state.spaceFilter}
              onChange={this.handleInputChange}
              label={capitalizeFirstLetter(this.props.spaceType)}
              className="my-0"
              labelClassName={classNames("font-semibold", {
                "text-muted": this.isSearching(),
              })}
              disabled={this.isSearching()}
            />
            <FormGroup
              inputType="checkbox"
              name="lengthFilter"
              value={this.state.lengthFilter}
              onChange={this.handleInputChange}
              label={`Length: ${inchesToFeet(this.props.loa)}'`}
              className="my-0"
              labelClassName={classNames("font-semibold", {
                "text-muted": this.isSearching(),
              })}
              disabled={this.isSearching()}
            />
            <FormGroup
              inputType="checkbox"
              name="availableFilter"
              value={this.state.availableFilter}
              onChange={this.handleInputChange}
              label={this.availableLabel()}
              className="my-0"
              labelClassName={classNames("font-semibold", {
                "text-muted": this.isSearching(),
              })}
              disabled={this.isSearching()}
            />
          </div>
          <hr className="my-3" />
          <div
            id="quickAssignWindow"
            style={{ maxHeight: "50vh", overflowY: "auto" }}
          >
            {this.state.loadingSpaces ? (
              <h4 className="text-muted flex justify-center py-5">
                <i className="icon icon-spinner icon-spin" />
              </h4>
            ) : (
              this.renderSpaceGroups()
            )}
          </div>
        </div>
      </div>
    )
  }

  availableLabel() {
    return (
      <div>
        <i className="icon icon-circle-check-solid icon-fw text-status-green mr-2" />
        Available
      </div>
    )
  }

  render() {
    const unsavedChangeToSpace =
      this.props.assignment.space &&
      this.props.assignment.space.id !== this.props.assignment.space_id

    return (
      <div key={this.props.index}>
        {this.props.lastAssignmentHtml}
        {(this.state.editingSpace ||
          unsavedChangeToSpace ||
          this.props.isAddingNewAssignment) &&
          this.props.meterReadingPrompt()}
        <div className="mb-2 mt-4 flex justify-between">
          <div>Date range</div>
          <a
            href="#"
            onClick={(event) =>
              this.props.removeAssignment(event, this.props.index)
            }
          >
            Remove
          </a>
        </div>
        <div className="flex items-baseline">
          <div className="flex-grow">
            <FormGroup
              inputType="datepicker"
              name="start_date"
              startDate={this.props.arrival.format("YYYY-MM-DD")}
              endDate={this.props.departure.format("YYYY-MM-DD")}
              value={
                this.props.assignment.start_date &&
                moment(this.props.assignment.start_date)
              }
              onChange={(date) => this.handleDateChange(date, "start_date")}
            />
          </div>
          <div className="px-2">to</div>
          <div className="flex-grow">
            <FormGroup
              inputType="datepicker"
              name="end_date"
              startDate={
                this.props.assignment.start_date ||
                this.props.arrival.format("YYYY-MM-DD")
              }
              endDate={this.props.departure.format("YYYY-MM-DD")}
              value={
                this.props.assignment.end_date &&
                moment(this.props.assignment.end_date)
              }
              onChange={(date) => this.handleDateChange(date, "end_date")}
            />
          </div>
        </div>
        <div className="mb-2">Space</div>
        {isPresent(this.props.spaceName) && !this.state.editingSpace
          ? this.renderSpaceInput()
          : this.renderAssignWidget()}
        <hr className="mb-0 mt-5" />
      </div>
    )
  }
}

AssignmentForm.propTypes = {
  arrival: PropTypes.object,
  assignment: PropTypes.object.isRequired,
  assignmentChange: PropTypes.func.isRequired,
  contactBoat: PropTypes.object,
  departure: PropTypes.object,
  index: PropTypes.number.isRequired,
  isAddingNewAssignment: PropTypes.bool,
  lastAssignmentHtml: PropTypes.node,
  loa: PropTypes.number,
  meterReadingPrompt: PropTypes.func,
  removeAssignment: PropTypes.func.isRequired,
  reservationId: PropTypes.number,
  setGlobalState: PropTypes.func.isRequired,
  setLinearSpace: PropTypes.func,
  spaceName: PropTypes.string,
  spaceType: PropTypes.string,
}

export default AssignmentForm
